import React from "react";
import { Link } from "react-router-dom";
import {
  CalendarClock,
  CalendarX,
  LogOut,
  Scissors,
  Settings,
  SlidersHorizontal,
  Users,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";

const SETTINGS_ITEMS = [
  { to: "/panel/hizmetler", label: "Hizmetler", icon: Scissors, testId: "settings-option-hizmetler" },
  {
    to: "/panel/calisma-saatleri",
    label: "Çalışma Saatleri",
    icon: CalendarClock,
    testId: "settings-option-calisma-saatleri",
  },
  {
    to: "/panel/kapali-tarihler",
    label: "Kapalı Günler",
    icon: CalendarX,
    testId: "settings-option-kapali-gunler",
  },
  { to: "/panel/personel", label: "Personel", icon: Users, testId: "settings-option-personel" },
  { to: "/panel/ayarlar", label: "İşletme Profili", icon: SlidersHorizontal, testId: "settings-option-profile" },
];

export default function BusinessSettingsSheet({ businessName, onLogout }) {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="rounded-full border border-border bg-card hover:bg-secondary"
          aria-label="İşletme ayarlarını aç"
          data-testid="settings-cog-button"
        >
          <Settings className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent
        className="business-panel-light flex w-[320px] flex-col border-border bg-card p-0"
        data-testid="settings-sheet"
      >
        <SheetHeader className="border-b border-border p-6 text-left">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary text-primary-foreground">
              <Settings className="h-5 w-5" />
            </div>
            <div className="min-w-0">
              <SheetTitle className="truncate">{businessName || "İşletme Ayarları"}</SheetTitle>
              <SheetDescription className="mt-1">Yönetim seçenekleri</SheetDescription>
            </div>
          </div>
        </SheetHeader>

        <nav className="space-y-1 p-4" aria-label="İşletme ayarları">
          {SETTINGS_ITEMS.map((item) => {
            const Icon = item.icon;
            return (
              <SheetClose key={item.to} asChild>
                <Link
                  to={item.to}
                  className={
                    "flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-semibold "
                    + "transition-colors duration-200 hover:bg-secondary"
                  }
                  data-testid={item.testId}
                >
                  <Icon className="h-4 w-4 text-primary" />
                  {item.label}
                </Link>
              </SheetClose>
            );
          })}
        </nav>

        <div className="mt-auto border-t border-border p-4">
          <Button
            variant="ghost"
            className="w-full justify-start gap-3 hover:bg-secondary"
            onClick={onLogout}
            data-testid="logout-btn"
          >
            <LogOut className="h-4 w-4" />
            Çıkış Yap
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}